var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlbaran(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.31641,
    y: 8.61816,
    width: 8.36849,
    height: 8.36849,
    rx: 0.75,
    transform: "rotate(-90 5.31641 8.61816)",
    fill: "white",
    stroke: "#2D2D2D",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 5.31738,
    width: 18.5039,
    height: 8.36849,
    rx: 1.75,
    fill: "white",
    stroke: "#2D2D2D",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.31641,
    y: 18.7539,
    width: 8.36849,
    height: 8.36849,
    rx: 0.75,
    transform: "rotate(-90 5.31641 18.7539)",
    fill: "white",
    stroke: "#2D2D2D",
    strokeWidth: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.16797,
    y: 11.4023,
    width: 1.26693,
    height: 12.6693,
    rx: 0.633464,
    transform: "rotate(-90 3.16797 11.4023)",
    fill: "#2D2D2D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.33203,
    y: 12.6699,
    width: 0.633464,
    height: 6.33464,
    rx: 0.316732,
    transform: "rotate(-90 6.33203 12.6699)",
    fill: "#2D2D2D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6.33203,
    y: 13.9365,
    width: 0.633464,
    height: 6.33464,
    rx: 0.316732,
    transform: "rotate(-90 6.33203 13.9365)",
    fill: "#2D2D2D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.33203,
    y: 15.2031,
    width: 0.633464,
    height: 6.33464,
    rx: 0.316732,
    transform: "rotate(-90 6.33203 15.2031)",
    fill: "#2D2D2D"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6.33203,
    y: 16.4697,
    width: 0.633464,
    height: 6.33464,
    rx: 0.316732,
    transform: "rotate(-90 6.33203 16.4697)",
    fill: "#2D2D2D"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 17.7373,
    width: 0.633333,
    height: 3.16667,
    rx: 0.316667,
    transform: "rotate(-90 9.5 17.7373)",
    fill: "#2D2D2D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.75078,
    cy: 8.55156,
    r: 0.95,
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbaran);
export default __webpack_public_path__ + "static/media/Albaran.e09ea0ef169dca427a2fc54d9d89160d.svg";
export { ForwardRef as ReactComponent };